/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { AWSRegionsEnum } from './aWSRegionsEnum';


export interface AdminAMIAccessModifySpec { 
    ami_id: string;
    region_id: AWSRegionsEnum;
    service_type: ServiceTypeEnum;
    /**
     * Accounts to add to the AMI\'s accesslist
     */
    add_accounts?: Array<string>;
    /**
     * Accounts to remove to the AMI\'s accesslist
     */
    remove_accounts?: Array<string>;
}
export namespace AdminAMIAccessModifySpec {
}


